import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=e090b0cc&scoped=true&"
import script from "./activate.vue?vue&type=script&lang=js&"
export * from "./activate.vue?vue&type=script&lang=js&"
import style0 from "./activate.vue?vue&type=style&index=0&id=e090b0cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e090b0cc",
  null
  
)

export default component.exports